import Textarea from "components/common/Textarea";
import Dark from "styles/Dark";

export default Dark(Textarea);



// WEBPACK FOOTER //
// ./components/common/DarkTextarea.tsx